import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-focus-2-line text-primary-500 mr-2"></i>
              焦点专题
            </h2>
            <p className="text-foreground-500 text-sm">编辑精选重磅策划内容</p>
          </div>
          <div className="flex flex-nowrap gap-5 overflow-x-auto pb-4">
            {carouselItems.map((item, idx) => (
              <a
                key={idx}
                href="#carousel"
                className="group flex-shrink-0 w-[300px] sm:w-[340px] lg:w-[380px] bg-background-100 rounded-xl overflow-hidden cursor-pointer no-underline transition-colors hover:bg-background-200"
              >
                <div className="aspect-[16/10] bg-background-200 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs rounded-full font-medium mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}